export default __webpack_public_path__ + "static/media/conceptual-idea.1058d778.svg";